import { render } from "./CurrencyManager.vue?vue&type=template&id=bc13f68a"
import script from "./CurrencyManager.vue?vue&type=script&lang=js"
export * from "./CurrencyManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__